export default __webpack_public_path__ + "static/media/notFound.2434eab1.png";